exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-loading__wrap[data-v-6960bf6a]{-webkit-box-sizing:border-box;box-sizing:border-box}.list-loading__wrap .loading-image__wrap[data-v-6960bf6a]{width:100px;margin:0 auto}@media screen and (min-width:48em){.list-loading__wrap .loading-image__wrap[data-v-6960bf6a]{width:150px}}", ""]);

// exports
